module.exports = __webpack_public_path__ + "static/media/m-retail-img.cc1809f2.png";